const COMPANION_LOGIN_PATH_PREFIX = "/api/accounts/companion/login?login_challenge=";

/**
 * The bridge URL a companion app's sign-in sent here (ADR-0024), or null. Only our own API path
 * counts, so the page can never be made to send someone to another site.
 */
export function companionLoginPathOf(search: string): string | null {
  const path = new URLSearchParams(search).get("companion_login");
  return path !== null && path.startsWith(COMPANION_LOGIN_PATH_PREFIX) ? path : null;
}

/** Issued-IRI navigation returns through the server after sign-in, with HTML Accept. */
export function resolverLoginPathOf(search: string): string | null {
  const path = new URLSearchParams(search).get("resolver_login");
  return path !== null && path.startsWith("/id/") && !path.includes("\\") ? path : null;
}
